import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Inherit = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Inherit" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M12 1C15.3133 1 18 3.68672 18 7C18 9.97247 15.8373 12.4387 13 12.915V14.4336L16.0713 16.2764C16.8016 15.4914 17.8432 15 19 15C21.2093 15 23 16.7907 23 19C23 21.2093 21.2093 23 19 23C16.7907 23 15 21.2093 15 19C15 18.6677 15.0408 18.3449 15.1172 18.0361L12 16.166L8.88184 18.0361C8.95825 18.3449 9 18.6676 9 19C9 21.2093 7.20928 23 5 23C2.79072 23 1 21.2093 1 19C1 16.7907 2.79072 15 5 15C6.15658 15 7.19745 15.4917 7.92773 16.2764L11 14.4336V12.915C8.16273 12.4387 6 9.97247 6 7C6 3.68672 8.68672 1 12 1ZM5 17C3.89528 17 3 17.8953 3 19C3 20.1047 3.89528 21 5 21C6.10472 21 7 20.1047 7 19C7 17.8953 6.10472 17 5 17ZM19 17C17.8953 17 17 17.8953 17 19C17 20.1047 17.8953 21 19 21C20.1047 21 21 20.1047 21 19C21 17.8953 20.1047 17 19 17ZM12 3C9.79128 3 8 4.79128 8 7C8 9.20872 9.79128 11 12 11C14.2087 11 16 9.20872 16 7C16 4.79128 14.2087 3 12 3Z" fill="#000" />
  </StyledIcon>
));

Inherit.displayName = 'Inherit';

export { Inherit };
